import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import AdminHeader from "./admin_header";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "react-js-pagination";
import {FaSearch } from "react-icons/fa";
import Slider from '../images/slider.png'
import EditImg from '../images/edit_01.png'
import SaveImg from '../images/save.png'
import { apiCallingPost} from "../service";
let offset = "0"
function CMS() {
    const [siteList, setSiteList] = useState([])
    const [activepage,SetActivepage] = useState(1)
    const [itemsCountPerPage, setItemsCountPerPage] = useState("20")
    const [totalItemsCount, setTotalItemsCount] = useState(0)
    const [pageOffset, setPageOffset] = useState("0")
    const [searchText, setSearchText] = useState("")
    const [searchTextFlag, setSearchTextFlag] = useState(false)
    useEffect(()=> {
        getCenterList("");
    },[])
    const getCenterList = (searchKeyWord) => {
        let postData = {
            functionName: "viewListing",
            userId: window.sessionStorage.getItem("user_id"),
            searchKeyword: searchKeyWord.replaceAll(", ", "_"),
            offset: offset,
            max: itemsCountPerPage,
        };
        apiCallingPost(postData).then((data) => {
            if(data.data.success == "1") {
                setSiteList(data.data.result.siteList)
                setTotalItemsCount(data.data.result.totalCount)
            }
            else {
                setSiteList([])
                setTotalItemsCount('0')
            }
        })

    }
    const handlePageChange = (pageNumber) => {
        SetActivepage(pageNumber)
      var max;
      if (pageNumber === "1") {
        offset = "0";
      } else {
        offset = parseInt(pageNumber - 1) * itemsCountPerPage;
      }
      SetActivepage(pageNumber)
      setPageOffset(offset)
      getCenterList(searchText);
    };
    // const approveClick = (siteId) =>{
    //     const postData = {
    //       functionName: "approveNewDetails",
    //       siteId: siteId,
    //       contentDataId:'',
    //       singleApprove:''    
    //     }
    //     // console.log(postData)
    //     apiCallingPost(postData).then((data) => {
    //       if (data.data.success == 1) {
    //         // console.log('approveSiteDetails- ',data)
    //         alert("Saved successfully");
    //       }
    //     })
    //   }
      const searchHereDetails = () => {
        var search = document.getElementById("searchHere");
        search = search.value.toLowerCase();
        setSearchText(search)
        setSearchTextFlag(true)
        offset = "0"
        if(document.getElementById("searchHere").value != ""){
          getCenterList(search);
        }
        else {
        }
      }
      const allSearchDetails = () => {
        var search = document.getElementById("searchHere");
        search = search.value.toLowerCase();
        setSearchText(search)
        setSearchTextFlag(true)
        offset = "0"
        if(document.getElementById("searchHere").value === ""){
            getCenterList(search);
        }
      }

      const viewPage = (siteId) => {
        window.sessionStorage.setItem("siteId", siteId )
      }

  return (
    <div className="dashboard_wrapper">
       <AdminHeader/>
       <div className="dash_breadcrumbs">           
            <nav aria-label="breadcrumb">
            <div className="container">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/dashboard">Dashboard</a></li>
                <li className="breadcrumb-item active" aria-current="page">Store Details</li>
            </ol>
            </div>
        </nav>   
        <div className="container">
            <div className="heading_wrapper_div">
            <h1 className="view_reportsheading">Store Details</h1>
            <div className="cms_search">
            <div className="cms_input_div">
            <div className="position-relative w-100">
                <input type="text" className="cms_searchinput " id="searchHere" placeholder="Search" onKeyUp = {(e) => { allSearchDetails() }}/>
                <FaSearch className="cms_searchicon"/>
            </div> 
             <div className="input-group-append">
                <span className="input-group-text" onClick = {(e) => { searchHereDetails() }} id="searchHere" placeholder="Search Here" >Search</span>
            </div>
            </div>
            </div>
            </div>
            <div className="react_pagination"> 
                {totalItemsCount > 20 &&
            <Pagination
            activePage={activepage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={totalItemsCount/itemsCountPerPage}
            onChange={handlePageChange}
        />
                }
            </div>
            <div className="cms_dashboad_div">
                {/* {console.log("siteList=", siteList)} */}
                
                {totalItemsCount > 0 ?
                  siteList.map((data, i) => (
                    <div key={i} className="inner_cms_div" >
                        {/* <img src={Slider} className="inner_cms_img" alt="slider"/> */}
                        <div className="inner_cms_div_connt">
                            <div className="inner_cms_div_left">
                                <h2 className="inner_cms_divhead">{data.centerName.replaceAll('_', ', ')}</h2>
                                <p className="inner_cms_siteId"> {"Site Id - "+data.siteId}</p>
                                <p className="inner_cms_divpara"> {data.centreAddress+", "+data.cityName+", "+data.pinCode}</p>
                            </div>
                            {/* <div className="inner_cms_div_right ">
                                <div className="inner_cms_div_img">
                                    <Link
                                    to={"/" 
                                    +data.displayName.replaceAll('_', '-').replaceAll(',', '').replaceAll(/ /g, "-")}
                                    onClick = { (e) => viewPage(data.siteId) }
                                    // href="/locator" 
                                  className="locator_cms_ancher"><img src={EditImg} className="inner_cms_div_imgdiv" alt="edit"/></Link>
                                </div>
                                
                                {window.sessionStorage.getItem("roleName") === "SuperAdmin" &&
                                <div className="inner_cms_div_img">
                                    <span  onClick={(e) => { approveClick(data.siteId) }} className="locator_cms_ancher nnnnnn"><img src={SaveImg} className="inner_cms_div_imgdiv" alt="save"/></span>
                                </div>
                                }
                                
                            </div> */}
                        </div> 
                        {window.sessionStorage.getItem("roleName") == "SuperAdmin" &&
                        <div className="inner_cms_div_connt_footer text-muted">                           
                                {data.modifiedSections.length > 0 ?
                              data.modifiedSections.map((obj,i)=>(
                                <div>
                              {obj === "About"? 
                                <span className="ribbon">Center Image</span>:
                                obj === "Centre Details"? 
                                <span className="ribbon">Centre Details</span>:
                                obj === "Services"?
                                <span className="ribbon">Services</span>:
                                ''
                                }
                                </div>
                              ))
                            : "No Modifications Available"}
                        </div>
                        }
                    </div>
                  ))
                :
                <p className="text-danger">No data found</p>
              }
            </div>
            <div className="react_pagination">
            {/* <Pagination
            activePage={activepage}
            itemsCountPerPage={5}
            totalItemsCount={450}
            pageRangeDisplayed={5}
            onChange={()=> pageChange()}
        /> */}
            </div>
        </div>       
       </div>
    </div>
  );
}

export default CMS;
